import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import '../../styles/PartCard.css';
import { AssistancePartListDTO } from '../../models/AssistanceParts/AssistancePartListDTO';
import ButtonComponent from '../ButtonComponent';

export type NewRequestPartCardProps = {
    part: AssistancePartListDTO;
    onRemove: () => void;
    isLocked: boolean;
    isLoading: boolean;
};

export const NewRequestPartCard: React.FC<NewRequestPartCardProps> = ({
    part,
    onRemove,
    isLocked,
    isLoading,
}) => {
    const intl = useIntl();
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className="part-card">
            <div className="part-card__icon-container">
                <div className="part-card__quantity">
                    QTD: {part.quantity}
                </div>
            </div>
            <div className="part-card__content">
                <div className="part-card__code" style={{ marginBottom: '8px' }}>
                    {part.erpId}
                </div>
                <div className="part-card__name" style={{ marginBottom: '12px' }}>
                    {part.name}
                </div>

                {part.requestPartDescription && (
                    <>
                        <button
                            className="part-card__select-button"
                            onClick={() => setIsExpanded(!isExpanded)}
                            style={{ marginBottom: '8px' }}
                        >
                            {isExpanded
                                ? intl.formatMessage({ id: "ExecutionsTableComponent.Close" })
                                : intl.formatMessage({ id: "ExecutionsTableComponent.Open" })
                            }
                            {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                        </button>
                        {isExpanded && (
                            <div style={{
                                padding: '12px',
                                backgroundColor: '#f5f5f5',
                                borderRadius: '8px',
                                marginBottom: '12px',
                                fontSize: '0.9rem',
                                lineHeight: '1.5'
                            }}>
                                <strong><FormattedMessage id="Screens.Assistances.Parts.Table.PartDescription" />:</strong>
                                <div style={{ marginTop: '4px' }}>{part.requestPartDescription}</div>
                            </div>
                        )}
                    </>
                )}

                <div className="part-card__action">
                    <ButtonComponent
                        text={intl.formatMessage({ id: "PartNewRequestComponent.Remove" })}
                        disabled={isLocked || isLoading}
                        onClick={onRemove}
                        style={{ width: '100%' }}
                    />
                </div>
            </div>
        </div>
    );
};
